export const REGISTRATION_STEP1 = 'registrationStep1';
export const REGISTRATION_STEP2 = 'registrationStep2';
export const LOGIN_PAGE = 'loginPage';
export const REGISTRATION_PAGE = 'registrationPage';
